import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Link from '@mui/material/Link';
import EntityTableRow, { EntityTableRowProps } from 'components/EntityTableRow';
import TableCell from 'components/TableCell';

import { WhatToSeeListRow_whatToSee$key } from '__generated__/WhatToSeeListRow_whatToSee.graphql';

type Props = EntityTableRowProps & {
  whatToSee: WhatToSeeListRow_whatToSee$key;
};

const WhatToSeeListRow: FC<Props> = ({ whatToSee, ...props }) => {
  const whatToSeeData = useFragment(
    graphql`
      fragment WhatToSeeListRow_whatToSee on WhatToSee {
        id
        name
        location

        ...EntityTableRow_entity
      }
    `,
    whatToSee
  );

  const { id, name, location } = whatToSeeData;

  return (
    <EntityTableRow entity={whatToSeeData} {...props}>
      <TableCell>
        <Link href={id}>{name}</Link>
      </TableCell>

      <TableCell center>{location}</TableCell>
    </EntityTableRow>
  );
};

export default WhatToSeeListRow;
